<template>
<div class="message-view">

    <InvestorBody>

        <div>
            <h1>
                <ol class="breadcrumb">
                    <li>
                        <router-link :to="{name:'messages'}">Messages</router-link>
                    </li>
                    <li>
                        {{supportTicket.description}}
                    </li>
                </ol>
            </h1>

			<div v-if="supportTicket.is_resolved == 'f'" class="card">
                <SendMessageMenu @close="$router.push({name:'messages'})"></SendMessageMenu>
            </div>
            <div v-else>
                You cannot send messages in resolved tickets. Please open a new ticket if you have any more inquires.
            </div>

            <TicketMessageList ref="messageList"></TicketMessageList>
            
        </div>

    </InvestorBody>

</div>
</template>

<script>
import {
    mapGetters
} from "vuex";
import store from "@/store";
import TicketMessageList from "@/components/support/TicketMessageList";
import SendMessageMenu from "@/components/support/SendMessageMenu";
import Cover from "../components/layout/Cover.vue";
import InvestorBody from "../components/layout/InvestorBody.vue";
export default {
    name: "TicketMessageView",

    components: {
        SendMessageMenu,
        TicketMessageList,
        Cover,
        InvestorBody
    },

    data() {
        return {};
    },
    beforeRouteEnter(to, from, next) {
        var params = {
            offset: 0,
            limit: 20,
            id: to.params.id
        }
        if (store.getters.user.is_investor) {
            store.dispatch("loadTicketMessages", params).then(function () {
                store.dispatch("loadInvestorSupportTicket", to.params.id).then(function () {
                    next();
                })
				store.dispatch("loadInvestorUnreadTickets");
            }).catch(function () {
                next({
                    name: "home"
                })
            });
        } else {
            next({
                name: "home"
            })
            return;
        }
    },

    beforeRouteUpdate(to, from, next) {
        var params = {
            offset: 0,
            limit: 20,
            id: to.params.id
        }
        if (store.getters.user.is_investor) {
            store.dispatch("loadTicketMessages", params).then(function () {
                store.dispatch("loadInvestorSupportTicket", to.params.id).then(function () {
                    next();
                })
            }).catch(function () {
                next({
                    name: "home"
                })
            });
        } else {
            next({
                name: "home"
            })
            return;
        }
    },

    methods: {

    },
    computed: {
        ...mapGetters(["user", "supportTicket", "supportTicketMessages", "supportTicketMessagesCount"]),
    },
};
</script>
